import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Upload as UploadAntd,
  Image
} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { ExclamationCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
const s3Config = {
  region: 'us-east-1',
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
};

const { TextArea } = Input;
const Search = Input.Search;
const { Option } = Select;
const s3Client = new S3Client(s3Config);
function Category() {
  const { request } = useRequest();
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [selected, setSelected] = useState();

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => {
        return (
          <div>
            <Image src={image} />
          </div>

        );
        // { is_active ? "Active" : "Inactive" }

      },
    },
    {
      title: "Category Name",
      dataIndex: "name",
      key: "name",
    },

    {
      title: "Action",
      render: (_, record) => {
        return (
          <Button
            className="tb-view"
            onClick={() => { setVisible(true); setSelected(record) }}
          >
            <i className="fa fa-light fa-pencil"></i> Edit
          </Button>
        );
      },
    },
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText]);

  const fetchData = (pagination, filters) => {
    request({
      url: `/admin/category/list?page=${pagination.current}&limit=${pagination.pageSize}&search=${debouncedSearchText}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.docs);
        setPagination({ current: pagination.current, total: data.data.totalDocs });
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  return (
    <Main>
      <div className="tabled">
        <Row>
          <Col xs="24" md={24} lg={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Category Management"
              extra={
                <>
                  <Search
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                  />
                  <Button onClick={() => setVisible(true)}>Add Category</Button>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={pagination}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddFrom
          show={visible}
          hide={() => { setSelected(); setVisible(false); }}
          data={selected}
          refresh={() => setRefresh(prev => !prev)}
        />
      )}
    </Main>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [file, setFile] = useState([]);

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "pharmacy/category" + file.name
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      console.log(data)
      return data;
    } catch (err) {
      throw err;
    }
  };
  const handleChange = async (event) => {
    const { file } = event;
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, 'invent-colab-obj-bucket');
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: 'done',
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (data) form.setFieldsValue({ ...data });
  }, [data]);



  const onCreate = (values) => {
    setLoading(true);
    let payload = {}
    payload.name = values.name
    payload.image = file.length > 0 ? file[0].url : null
    request({
      url: data ? `/admin/category/edit-category/${data._id}` : `/admin/category/add-category`,
      method: data ? 'PUT' : 'POST',
      data: payload,
      onSuccess: () => {
        setLoading(false);
        refresh();
        hide();
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={show}
      title={`${data ? 'Edit' : 'Create'} Category`}
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">


        <Form.Item
          label="Project Name"
          name="name"
          rules={[{ required: true, message: "Please enter the location name!" }]}
        >
          <Input />
        </Form.Item>






      </Form>
      <Col span={24}>
        <UploadAntd
          listType="picture"
          maxCount={1}
          customRequest={handleChange}
          onRemove={(e) => setFile([])}
          fileList={file}
        >
          {file.length > 0 ? null : <Button icon={<UploadOutlined />}>Upload</Button>}
        </UploadAntd>
      </Col>
    </Modal>
  );
};

export default Category;
